import _slicedToArray from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { entries, isEmpty } from '../../../util';
import { getMarkPropOrConfig, signalOrValueRef } from '../../common';
import { VG_MARK_INDEX } from './../../../vega.schema';
import { wrapCondition } from './conditional';
import { textRef } from './text';
import { tooltipData } from './tooltip';
export function aria(model) {
  var markDef = model.markDef,
      config = model.config;
  var enableAria = getMarkPropOrConfig('aria', markDef, config); // We can ignore other aria properties if ariaHidden is true.

  if (enableAria === false) {
    // getMarkGroups sets aria to false already so we don't have to set it in the encode block
    return {};
  }

  return Object.assign(Object.assign(Object.assign({}, enableAria ? {
    aria: enableAria
  } : {}), ariaRoleDescription(model)), description(model));
}

function ariaRoleDescription(model) {
  var mark = model.mark,
      markDef = model.markDef,
      config = model.config;

  if (config.aria === false) {
    return {};
  }

  var ariaRoleDesc = getMarkPropOrConfig('ariaRoleDescription', markDef, config);

  if (ariaRoleDesc != null) {
    return {
      ariaRoleDescription: {
        value: ariaRoleDesc
      }
    };
  }

  return mark in VG_MARK_INDEX ? {} : {
    ariaRoleDescription: {
      value: mark
    }
  };
}

export function description(model) {
  var encoding = model.encoding,
      markDef = model.markDef,
      config = model.config,
      stack = model.stack;
  var channelDef = encoding.description;

  if (channelDef) {
    return wrapCondition(model, channelDef, 'description', function (cDef) {
      return textRef(cDef, model.config);
    });
  } // Use default from mark def or config if defined.
  // Functions in encode usually just return undefined but since we are defining a default below, we need to check the default here.


  var descriptionValue = getMarkPropOrConfig('description', markDef, config);

  if (descriptionValue != null) {
    return {
      description: signalOrValueRef(descriptionValue)
    };
  }

  if (config.aria === false) {
    return {};
  }

  var data = tooltipData(encoding, stack, config);

  if (isEmpty(data)) {
    return undefined;
  }

  return {
    description: {
      signal: entries(data).map(function (_ref, index) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return "\"".concat(index > 0 ? '; ' : '').concat(key, ": \" + (").concat(value, ")");
      }).join(' + ')
    }
  };
}